// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { newGuid } from './../../lib/uuid';

// Do not mutate this value - App Insight queries/dashboards could be statically tied to this
export const REQUEST_RESPONSE_EVENT_NAME = 'RequestResponse';
const ONE_DAY_IN_MILLISECONDS = 1000*60*60*24;

export const disableLocalhostTelemetry = true;
export const sessionId = newGuid().toLowerCase();
if (document && document.cookie) {
    document.cookie = `ai_session=${sessionId}`;
}
export const sessionExpirationMs = ONE_DAY_IN_MILLISECONDS;
